import { StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { inject, Injectable } from '@angular/core';
import { Value } from '@angular/fire/remote-config';
import { Action, NgxsAfterBootstrap, Selector, State } from '@ngxs/store';
import { RemoteConfigService } from '../../firebase/remote-config/firebase-remote-config.service';
import { RemoteConfigActions } from './remote-config.action';
import { RemoteConfigStateModel } from './remote-config.store';

@StateRepository()
@State<RemoteConfigStateModel>({
  name: 'remoteConfigs',
  defaults: { remoteConfig: null },
})
@Injectable()
export class RemoteConfigState extends NgxsDataRepository<RemoteConfigStateModel> implements NgxsAfterBootstrap {
  remoteConfigService = inject(RemoteConfigService);

  override ngxsAfterBootstrap() {
    super.ngxsAfterBootstrap();
    this.remoteConfigService
      .getAllValueAsync()
      .then((remoteConfig) => this.setState({ remoteConfig }))
      .catch((error: unknown) => console.error('Failed to load the remote config on bootstrap', error));
  }

  @Action(RemoteConfigActions.SetRemoteConfig)
  async setRemoteConfig() {
    this.setState({ remoteConfig: await this.remoteConfigService.getAllValueAsync() });
  }

  @Action(RemoteConfigActions.DeleteRemoteConfigs)
  saveRemoteConfig() {
    this.setState({ remoteConfig: null });
  }

  @Selector()
  static remoteConfig(state: RemoteConfigStateModel) {
    return state.remoteConfig;
  }

  @Selector()
  static providerDataWithIsVerified(state: RemoteConfigStateModel): { remoteConfig: Record<string, Value> | null } {
    return {
      remoteConfig: state.remoteConfig || null,
    };
  }
}
